"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

var _color = _interopRequireDefault(require("color"));

var _utils = require("../utils");

var _default = _interopRequireDefault(require("../config/default.json"));

var _LottieOutroAPI2 = _interopRequireDefault(require("./LottieOutroAPI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function onDOMLoaded() {
  this.DOMLoaded = true;
  this.animation.removeEventListener('DOMLoaded', this.BindOnDOMLoaded);
  isReady(this);
}

function onLoadedImages() {
  this.imagesLoaded = true;
  this.animation.removeEventListener('loaded_images', this.BindOnLoadedImages);
  isReady(this);
}

function isReady(_self) {
  if (_self.DOMLoaded && _self.imagesLoaded) {
    _self.ready = true;

    _self.animation.trigger('ready');

    if (typeof _self.afterReady === 'function') {
      _self.afterReady();
    }
  }
}

function getLogoUrl(logo) {
  var targetW = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var targetH = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  var cdn = arguments.length > 3 ? arguments[3] : undefined;
  var _logo$style = logo.style,
      imageOriginWidth = _logo$style.imageOriginWidth,
      imageOriginHeight = _logo$style.imageOriginHeight;
  var logoUrl = (0, _utils.NormalizeBaseUrl)(logo.value);
  var crop = {
    w: imageOriginWidth,
    h: imageOriginHeight,
    x: 0,
    y: 0
  };
  return (0, _utils.CropImage)(logoUrl, crop, targetW, targetH, cdn);
}

function findElem(key, elements) {
  var el = null;
  elements.forEach(function (elem) {
    var name = elem.constructor.name;

    if (name === 'SVGCompElement') {
      var item = findElem(key, elem.elements);

      if (item) {
        el = item;
      }
    } else if (name === 'SVGTextElement' && elem.data.nm === key) {
      el = elem;
    }
  });
  return el;
}

var LottieAnimationBase = /*#__PURE__*/function (_LottieOutroAPI) {
  _inherits(LottieAnimationBase, _LottieOutroAPI);

  var _super = _createSuper(LottieAnimationBase);

  function LottieAnimationBase(animObj, data, config) {
    var _this;

    _classCallCheck(this, LottieAnimationBase);

    _this = _super.call(this);
    _this.config = config;
    _this.userFonts = animObj.fonts;
    _this.inDuration = config.inDuration;
    _this.intermissionDuration = config.intermissionDuration;
    _this.outDuration = config.outDuration;
    _this.totalDuration = config.totalDuration;
    return _this;
  }
  /**
   * _loadAnimation() load lottie animation (private function)
   * load the lottie animation update animation data with size and fonts before load
   * set animation position and size if animation include style object
   */


  _createClass(LottieAnimationBase, [{
    key: "_loadAnimation",
    value: function _loadAnimation(data, container) {
      this.container = container;
      var style = {};
      this.innerContainer = document.createElement('span');

      _gsap.TweenMax.set(this.innerContainer, style);

      this.container.appendChild(this.innerContainer);
      this.animation = _lottieWeb.default.loadAnimation({
        container: this.innerContainer,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: data
      }); // wait for image to be load than trigger custom ready event

      this.BindOnLoadedImages = onLoadedImages.bind(this);
      this.animation.addEventListener('loaded_images', this.BindOnLoadedImages);
      this.BindOnDOMLoaded = onDOMLoaded.bind(this);
      this.animation.addEventListener('DOMLoaded', this.BindOnDOMLoaded);
    }
  }, {
    key: "_setImageFolder",
    value: function _setImageFolder(animation) {
      var imgFolderPattern = new RegExp('images/', 'g');
      return animation.replace(imgFolderPattern, '');
    }
  }, {
    key: "_setInputs",
    value: function _setInputs(animation, data, inputs, animObj) {
      inputs.forEach(function (input) {
        var pattern = new RegExp(input.pattern, 'g');
        var value = '';

        if (data.hasOwnProperty(input.name)) {
          value = data[input.name].value;
        } else {
          value = input.value;
        }

        switch (input.type) {
          case 'logo':
            value = data[input.name].value;
            break;

          case 'image':
            if (!value || value === '') {
              value = _default.default.transparentPixle;
            } else {
              value = (0, _utils.NormalizeBaseUrl)(value);
            }

            break;

          case 'color':
            value = "\"t\":\"".concat((0, _utils.colorConvertLottie)((0, _color.default)(value).rgb().array()).join(','));
            pattern = new RegExp("\"t\":\"".concat(input.pattern), 'g');
            break;

          case 'text':
          default:
            value = "\"t\":\"".concat((0, _utils.NormalizeTemplateText)(value));
            pattern = new RegExp("\"t\":\"".concat(input.pattern), 'g');
            break;
        }

        animation = animation.replace(pattern, value);
      });
      return animation;
    }
  }, {
    key: "updateInput",
    value: function updateInput(key, value) {
      var input = this.config.inputs.find(function (obj) {
        return obj.name === key;
      });

      if (input && (input.type === 'text' || input.type === 'color')) {
        var pattern = input.pattern,
            type = input.type;
        var element = findElem(pattern, this.animation.renderer.elements);

        var _value;

        if (element) {
          switch (type) {
            case 'color':
              _value = (0, _utils.colorConvertLottie)((0, _color.default)(value).rgb().array()).join(',');
              break;

            case 'text':
            default:
              _value = value;
              break;
          }

          if (element.updateDocumentData) {
            element.updateDocumentData({
              t: _value
            });

            if (this.animation.isPaused) {
              var currentTime = this.animation.currentFrame * 40;
              this.goToAndStop(currentTime + 1);
              this.goToAndStop(currentTime - 1);
            }

            return true;
          }
        }
      }

      return false;
    }
  }, {
    key: "prepareAssets",
    value: function prepareAssets() {
      window.console.log('TEMPLATE2.0 - prepareAssets');
      var assetPromises = this.json.assets.filter(function (asset) {
        return asset.id.indexOf('image') !== -1;
      }).filter(function (asset) {
        return asset.p.substring(0, 5) !== 'data:';
      }).map(function (asset) {
        return (0, _utils.toDataURL)(asset.p, 'TEMPLATE2.0').then(function (b64) {
          asset.p = b64;
        });
      });
      return Promise.all([(0, _utils.LoadFonts)(this.userFonts, 7000)].concat(_toConsumableArray(assetPromises)));
    }
  }]);

  return LottieAnimationBase;
}(_LottieOutroAPI2.default);

exports.default = LottieAnimationBase;